<template>
  <div class="tla-form-group tla-form-group--margin-medium">
    <label class="tla-form-group__label tla-form-group__label--required" v-html="additionalVehicleInterestLabel"></label>

    <div class="tla-form-group__touch-points">
      <touchpoint v-for="(item) in options"
        :key="item.touchpointValue"
        :collectionName="'additionalVehicleInterest'"
        :inputId="item.touchpointValue"
        :inputValue="item.touchpointValue"
        :isSelected="item.preSelect"
        :isRadioStyle="true"
        :validationScope="validationScope"
        @additionalVehicleInterest="submitAdditionalVehicleInterest($event)">
        <div class="generic-touchpoint__text" slot="touchpoint" v-html="item.touchpointName"></div>
      </touchpoint>
    </div>
    <span class="tla-form-group__message" :class="getValidationClass('additionalVehicleInterest', 'message')">
      Please select an option.
    </span>
  </div>
</template>

<script lang="ts">
import Vue from 'vue';
import { Component, Prop, Inject } from 'vue-property-decorator';
import { Validator } from 'vee-validate';
import { validationService } from '@/services/ValidationService';
import GenericTouchPointComponent from '../ui/GenericTouchPointComponent.vue';
import Touchpoint from '../../models/Touchpoint';
import ExtraData from '../../models/ExtraData';

@Component({
  components: {
  touchpoint: GenericTouchPointComponent
  }
  })
export default class AdditionalVehicleInterestComponent extends Vue {
  @Inject('$validator') public $validator!: Validator;

  @Prop({ default: 'Are you considering other makes/models of car? <span>*</span>' })
  public additionalVehicleInterestLabel!: string;

  @Prop({ default: null })
  public validationScope!: string;

  public options: Touchpoint[] = [
    new Touchpoint('true', 'Yes'),
    new Touchpoint('false', 'No')
  ];

  public submitAdditionalVehicleInterest(value: string) {
    const extraData: ExtraData = new ExtraData('additionalVehicleInterest', value);
    this.$store.dispatch('enquiryModule/submitExtraData', extraData);
  }

  public getValidationClass(fieldName: string, fieldType: string) {
    return validationService
      .getValidationClass(this.$validator, fieldName, fieldType, false, false, this.validationScope);
  }
}
</script>
